export default __webpack_public_path__ + "static/media/cabourg9.19e71ad3.jpg";